var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorRoundedWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4162_9136)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.3707,
    cy: 30.4999,
    r: 20.9061,
    fill: "#FE2142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3707 -0.046875C13.5114 -0.046875 -0.177002 13.6416 -0.177002 30.5009C-0.177002 47.3601 13.5114 61.0486 30.3707 61.0486C47.23 61.0486 60.9185 47.3601 60.9185 30.5009C60.9185 13.6416 47.23 -0.046875 30.3707 -0.046875ZM26.0482 30.5009L17.4093 21.8589C16.218 20.6675 16.218 18.7308 17.4093 17.5395C18.6007 16.3481 20.5374 16.3481 21.7288 17.5395L30.3707 26.1814L39.0096 17.5395C40.201 16.3481 42.1377 16.3481 43.3291 17.5395C44.5235 18.7308 44.5235 20.6675 43.3291 21.8589L34.6902 30.5009L43.3291 39.1398C44.5235 40.3311 44.5235 42.2678 43.3291 43.4592C42.1377 44.6536 40.201 44.6536 39.0096 43.4592L30.3707 34.8203L21.7288 43.4592C20.5374 44.6536 18.6007 44.6536 17.4093 43.4592C16.218 42.2678 16.218 40.3311 17.4093 39.1398L26.0482 30.5009Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4162_9136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.1315,
    height: 61,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRoundedWhite);
export default __webpack_public_path__ + "static/media/error_rounded_white.61700c6cdf22da4d9bbc5975452e3bc6.svg";
export { ForwardRef as ReactComponent };